var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"filing"},[_vm._v(" CopyRight@2026 思远创-"),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("粤ICP备2021178996号-1")])])
}]

export { render, staticRenderFns }